var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_quote-white-18dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ledger-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Invoices_Account-Number-Text-Tooltip",
    transform: "translate(-738.000000, -188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(729.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "request_quote-white-18dp",
    transform: "translate(9.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1.5 L4.5,1.5 C3.675,1.5 3.0075,2.175 3.0075,3 L3,15 C3,15.825 3.6675,16.5 4.4925,16.5 L13.5,16.5 C14.325,16.5 15,15.825 15,15 L15,6 L10.5,1.5 Z M11.25,9 L8.25,9 L8.25,9.75 L10.5,9.75 C10.9125,9.75 11.25,10.0875 11.25,10.5 L11.25,12.75 C11.25,13.1625 10.9125,13.5 10.5,13.5 L9.75,13.5 L9.75,14.25 L8.25,14.25 L8.25,13.5 L6.75,13.5 L6.75,12 L9.75,12 L9.75,11.25 L7.5,11.25 C7.0875,11.25 6.75,10.9125 6.75,10.5 L6.75,8.25 C6.75,7.8375 7.0875,7.5 7.5,7.5 L8.25,7.5 L8.25,6.75 L9.75,6.75 L9.75,7.5 L11.25,7.5 L11.25,9 Z M9.75,6 L9.75,2.625 L13.125,6 L9.75,6 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuote);
export default __webpack_public_path__ + "static/media/request_quote.acb95111c03b4e3908872647ffad8697.svg";
export { ForwardRef as ReactComponent };